import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initLIFF } from './lib/liff';

const initializeApp = async () => {
  try {
    await initLIFF();
  } catch (error) {
    console.error('LIFF initialization failed:', error);
  }

  const root = document.getElementById('root')!;
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
};

initializeApp();
